<template>
    <v-container fill-height justify-center v-if="progress">
        <div class="text-center">
            <v-progress-circular
              :rotate="2"
              :size="100"
              :width="10"
              color="primary"
              indeterminate
            >
            </v-progress-circular>
        </div>
    </v-container>

    <v-container fluid fill-height v-else>
        <v-layout justify-center row pa-4 v-if="items.length > 0">
            <v-flex xs12 sm10 md6>
                <v-flex class="mb-3" text-center>
                    <h2>รายการพัสดุ</h2>
                </v-flex>
                <v-expansion-panels class="my-4">
                    <v-expansion-panel v-for="(groupDate, key) in groupsDate" :key="key">
                        <v-expansion-panel-header>
                            <v-flex justify="space-around" align="center">
                                <span><b>วันที่ขอรับ {{ key }}</b></span>
                                <!--                                <span v-else><b>รายการวันพรุ่งนี้</b></span>-->
                            </v-flex>
                            <v-flex class="text-right">
                                <v-chip class="ma-2"
                                        color="blue-grey"
                                        text-color="white">
                                    <v-avatar left class="blue-grey darken-4"> {{ groupDate.length }}
                                    </v-avatar>
                                    ชิ้น
                                </v-chip>
                            </v-flex>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <div class="my-2 mt-4" v-for="(item, index) in groupDate" :key="index">
                                <v-card class="mx-auto my-2"
                                        @click="selectedParcel(items, index, item.SU_RUNNO)"
                                        style="border-left:solid 5px #0045AF;background: #f3f4f6">
                                    <v-row>
                                        <v-col class="text-center my-auto" cols="3">
                                            <v-icon large color="blue darken-2">mdi-package-variant-closed</v-icon>
                                        </v-col>
                                        <v-col cols="7">
                                            <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>
                                            <v-card-text style="color: #ff2e34; font-size: 18px">เลขที่อ้างอิง : {{
                                                    item.SU_CODE
                                                }}
                                            </v-card-text>
                                            <v-card-text>เวลาที่บันทึก : {{
                                                    item.CREATE_DATE.substring(11, 16)
                                                }}
                                            </v-card-text>
                                            <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>
                                            <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>
                                            <v-card-text>ประเภทพัสดุ : {{ item.ST_REMARK }}</v-card-text>
                                        </v-col>
                                        <v-col cols="2" class="text-center my-auto">
                                            <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold
                                            </v-icon>
                                        </v-col>
                                    </v-row>
                                </v-card>
                                <!--                                <v-card class="mx-auto my-2"-->
                                <!--                                        v-else-->
                                <!--                                        style="border-left:solid 5px #0045AF;background: #f3f4f6">-->
                                <!--                                    <v-row>-->
                                <!--                                        <v-col class="text-center my-auto" cols="3">-->
                                <!--                                            <v-icon large color="blue darken-2">mdi-package-variant-closed</v-icon>-->
                                <!--                                        </v-col>-->
                                <!--                                        <v-col cols="7">-->
                                <!--                                            <v-card-title>พัสดุคุณ {{ item.SU_FULLNAME }}</v-card-title>-->
                                <!--                                            <v-card-text style="color: #ff2e34">เลขที่อ้างอิง : {{ item.SU_CODE }}-->
                                <!--                                            </v-card-text>-->
                                <!--                                            <v-card-text>เลขที่ห้อง : {{ item.PD_ADDR }}</v-card-text>-->
                                <!--                                            <v-card-text>เลขที่พัสดุ : {{ item.SU_BARCODE }}</v-card-text>-->
                                <!--                                        </v-col>-->
                                <!--&lt;!&ndash;                                        <v-col cols="2" class="text-center my-auto">&ndash;&gt;-->
                                <!--&lt;!&ndash;                                            <v-icon v-if="item.CLICK == 1" large color="green darken-3">mdi-check-bold&ndash;&gt;-->
                                <!--&lt;!&ndash;                                            </v-icon>&ndash;&gt;-->
                                <!--&lt;!&ndash;                                        </v-col>&ndash;&gt;-->
                                <!--                                    </v-row>-->
                                <!--                                </v-card>-->
                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                <v-row>
                    <v-col cols="12">
                        <v-btn color="#33691E"
                               block
                               large
                               dark
                               @click="submit()">
                            รับผ่าน Lobby
                        </v-btn>
                    </v-col>
                    <!-- <v-col cols="6">
                        <v-btn color="#1565C0"
                               block
                               large
                               dark>
                            เข้าตู้ Box24
                        </v-btn>
                    </v-col> -->
                </v-row>                
                <!-- <v-row>
                    <v-col cols="6">
                        <v-btn color="#0e64ea"
                               block
                               large
                               dark
                               @click="submitExcel()">
                            Excel
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="#1a50a6"
                               block
                               large
                               dark
                               @click="submitPDF()">
                            PDF
                        </v-btn>
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col cols="6"></v-col>
                    <v-col cols="6"></v-col>
                </v-row>
            </v-flex>
        </v-layout>
        <v-layout justify-center row pa-5 v-else>
            <v-flex class="mb-3" text-center>
                <h2>ไม่มีรายการพัสดุ</h2>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-card-title class="headline">ไม่มีรายการที่เลือก</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="dialog = false">
                        ตกลง
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog2" max-width="290" persistent>
            <v-card>
                <v-card-title>ยืนยันการนับพัสดุเข้าตู้</v-card-title>
                <v-card-actions>
                    <div class="flex-grow-1"></div>
                    <v-btn color="green darken-1"
                           text
                           @click="save()">
                        ตกลง
                    </v-btn>
                    <v-btn color="red darken-1"
                           text
                           @click="dialog2 = false">
                        ยกเลิก
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import EventBus from '@/EventBus'
import axios from '@/axios';

export default {
    name: "OTParcelListSubmit",
    data() {
        return {
            searchData: {
                ntRunno: this.getLocalItem().nt_runno,
                status: "'W'",
            },
            items: [],
            itemSelected: [],
            itemSelectedShow: [],
            progress: true,
            dialog: false,
            dialog2: false,
            today: new Date().toISOString().substr(0, 10),
        }
    },
    computed: {
        groupsDate() {
            return this.groupByData(this.items, 'REQUEST_DATE')
        },
    },
    mounted() {
        window.scrollTo(0, 0)
        EventBus.$emit('set_navigation', {title: 'รายการพัสดุนอกเวลา', back_route: 'main-menu'})

        let localItem = this.getLocalItem();
        delete localItem.itemSelected;
        delete localItem.itemsParcel;
        delete localItem.searchText;
        localStorage.setItem('parcel', JSON.stringify(localItem))

        this.listParcelOT()
    },
    methods: {
        selectedParcel(array, index, data) {
            const itemIndex = array.findIndex((e) => e.SU_RUNNO == data);   
            // console.log("itemIndex=",itemIndex);            
            if (array[itemIndex].CLICK === '1') {
                array[itemIndex].CLICK = '0'
                this.removeItem(this.itemSelected, data)
            } else {
                array[itemIndex].CLICK = '1'
                this.itemSelected.push(data)
            }
            // console.log('selectedParcel', this.itemSelected)
        },
        submit() {
            if (this.itemSelected.length === 0) {
                this.dialog = true
            } else {
                this.dialog2 = true
            }
        },
        submitExcel(){
            // console.log("submitExcel");
            let report = `https://reporting.lpn.co.th/flow.html?`
                +`_flowId=viewReportFlow`
                +`&_flowId=viewReportFlow`
                +`&ParentFolderUri=%2FReports%2FParcel&reportUnit=%2FReports%2FParcel%2Flpp_parcel_ot_excel`
                +`&standAlone=true`
                +`&j_username=reportviewer`
                +`&j_password=Dev@2019`
                +`&Status=W`
                +`&Runno=${this.searchData.ntRunno}`
                +`&output=xlsx`

            window.open(report);
        },
        submitPDF(){
            // console.log("submitPDF=",this.searchData.status);
            // console.log("submitPDF=",this.searchData.ntRunno);
            let report = `https://reporting.lpn.co.th/flow.html?`
                +`_flowId=viewReportFlow`
                +`&_flowId=viewReportFlow`
                +`&ParentFolderUri=%2FReports%2FParcel&reportUnit=%2FReports%2FParcel%2Flpp_parcel_ot`
                +`&standAlone=true`
                +`&j_username=reportviewer`
                +`&j_password=Dev@2019`
                +`&Status=W`
                +`&Runno=${this.searchData.ntRunno}`
                +`&output=pdf`

            window.open(report);
        },
        save() {
            this.saveParcelInBox(this.itemSelected)
        },
        async listParcelOT() {
            try {
                axios.post('/OTParcelList', this.searchData)
                  .then(res => {
                      // console.log('ParcelList', res.data)
                      this.items = res.data.data

                      let localItem = this.getLocalItem();
                      localItem.itemsParcel = res.data.data
                      localStorage.setItem('parcel', JSON.stringify(localItem))

                      let itemDefault = [];
                      let itemDefaultShow = [];
                      this.items.forEach(function (value) {
                          if (
                                  value.SU_STATUS === "S" ||
                                  value.SU_STATUS === "E" ||
                                  value.SU_STATUS === "W"
                          ) {
                              // console.log('items', value.SU_RUNNO)
                              itemDefault.push(value.SU_RUNNO);
                              itemDefaultShow.push(value.SU_CODE);
                          }
                          value.CLICK = "1";
                      });
                      this.itemSelected = itemDefault;
                      this.itemSelectedShow = itemDefaultShow;

                      this.progress = false

                    //   console.log('groupsDate', this.groupByData(this.items, 'REQUEST_DATE'))
                  })
            } catch (err) {
                console.log(err.message)
            }
        },
        async saveParcelInBox(itemSelected) {
            try {
                let username = this.getLocalItem().user_id
                itemSelected.forEach(function (su_runno) {
                    axios.post('/SaveParcelInBox', {su_runno: su_runno, username: username})
                      .then(res => {
                          console.log('SaveParcelInBox', res.data)
                      })
                    // console.log('SaveParcelOT', su_runno)
                })
                this.dialog2 = false
                this.progress = true
                let localItem = this.getLocalItem();
                delete localItem.itemSelected;
                delete localItem.itemsParcel;
                delete localItem.searchText;
                localStorage.setItem('parcel', JSON.stringify(localItem))
                this.listParcelOT()
            } catch (err) {
                console.log(err.message)
            }
        }
    }
}
</script>
